import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RtsCreatorService } from '../../services/rts-creator.service';

@Component({selector:'app-rts-quick-ticket',standalone:true,imports:[CommonModule,MatIconModule,MatButtonModule,MatMenuModule],
 template:`<button *ngIf="compact;else full" mat-icon-button aria-label="Create ticket" title="Create an IT, bug, or project ticket" (click)="open()"><mat-icon>add_comment</mat-icon></button><ng-template #full><button mat-button (click)="open()"><mat-icon>add_comment</mat-icon><span>Create ticket</span></button></ng-template>`,
 styles:[`:host{display:inline-block}button{color:inherit}`]})
export class QuickTicketComponent {
 @Input() compact=false;
 constructor(private creator:RtsCreatorService){}
 open(){this.creator.open();}
}
